import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';

type SierraChildDeviceDetailsEndpointSpecification = ApiEndpointSpecification;
export const SierraChildDeviceDetailsEndpointSpecification: SierraChildDeviceDetailsEndpointSpecification = {
    url: '/api/sierradevice/device',
    method: HttpMethod.POST,
    requestParamsSchemaName: 'SierrawirelessChildDeviceDetailsRequestParams',
    requestBodySchemaName: 'SierrawirelessChildDeviceDetailsRequestBody',
    okResponseSchemaName: 'SierrawirelessChildDeviceDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
};

export const invokeSierraChildDeviceDetails = Helpers.makeApiRequestFn<
    Types.SierraWirelessChildDeviceDetailsRequestParams,
    Types.SierraWirelessChildDeviceDetailsRequestBody,
    Types.SierraWirelessChildDeviceDetailsOkResponse
>(SierraChildDeviceDetailsEndpointSpecification);
